export const isValidMediaUrl = (url: string): boolean => {
  try {
    const parsedUrl = new URL(url)
    return (
      (parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:") &&
      parsedUrl.pathname !== "/"
    )
  } catch (error) {
    return false
  }
}
